<template>
    <vertical-text-image-section
        class="vertical-text-image-section-module"
        :title="attributes.verticalTextImageSection_title"
        :text="attributes.text"
        :top-desktop-image="topDesktopImage"
        :top-mobile-image="topMobileImage"
        :bottom-desktop-image="bottomDesktopImage"
        :bottom-mobile-image="bottomMobileImage"
        :fluid-container="attributes.fluid_container"
        :text-alignment="attributes.text_alignment"
        :background-variant="attributes.verticalTextImageSection_background_variant"
    />
</template>

<script>
    import VerticalTextImageSection from '../../../organisms/VerticalTextImageSection/VerticalTextImageSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'vertical-text-image-section-module',

        components: { VerticalTextImageSection },

        props: {
            attributes: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Return the top desktop image object.
             *
             * @returns {{src: string|undefined, alt: string|undefined}}
             */
            topDesktopImage() {
                return formatMediaObject.call(this, this.attributes.top_desktop_image);
            },

            /**
             * Return the top mobile image object.
             *
             * @returns {{src: string|undefined, alt: string|undefined}}
             */
            topMobileImage() {
                return formatMediaObject.call(this, this.attributes.top_mobile_image);
            },

            /**
             * Return the bottom desktop image object.
             *
             * @returns {{src: string|undefined, alt: string|undefined}}
             */
            bottomDesktopImage() {
                return formatMediaObject.call(this, this.attributes.bottom_desktop_image);
            },

            /**
             * Return the bottom mobile image object.
             *
             * @returns {{src: string|undefined, alt: string|undefined}}
             */
            bottomMobileImage() {
                return formatMediaObject.call(this, this.attributes.bottom_mobile_image);
            },
        },
    };
</script>
